module.exports = __webpack_public_path__ + "media/application/images/svgs/divide-circle-2969ba7eba12332cd808f8c3699926bc.svg";